import Icon from '@ant-design/icons';

const NdeMixedSvg = () => (
  <svg width="1.1em" height="1.1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 700" fill="currentColor">
    <g>
      <path d="M601.1,598.8c-1.7-1.8-41.4-40.6-127-60.1c4-6.7,7.4-13.9,9.9-21.3h5.9c19.3,0,35-15.7,35-35s-15.7-35-35-35V465
		c9.7,0,17.5,7.8,17.5,17.5s-7.8,17.5-17.5,17.5h-1.6c0.9-5.7,1.6-11.5,1.6-17.5h-17.5c0,57.9-54.9,105-122.5,105
		s-122.5-47.1-122.5-105h-17.5c0,6,0.6,11.8,1.6,17.5h-1.6c-9.7,0-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5v-17.5
		c-19.3,0-35,15.7-35,35s15.7,35,35,35h5.9c2.5,7.4,5.9,14.5,9.9,21.3c-85.6,19.5-125.2,58.3-127,60.1l12.4,12.4
		c0.4-0.4,40-39,125.7-56.8c25.5,30.6,66.6,50.7,113.2,50.7c46.5,0,87.7-20,113.2-50.7c85.2,17.8,125.3,56.5,125.7,56.9L601.1,598.8
		z"/>
      <path d="M323.7,447.5v35c0,14.5,11.8,26.2,26.2,26.2c14.5,0,26.3-11.8,26.3-26.2v-35h-17.5v35c0,4.8-3.9,8.8-8.8,8.8
		c-4.8,0-8.7-3.9-8.7-8.8v-35H323.7z"/>
      <path d="M305.8,543.7c1.5,0.4,5.1,4.1,7.3,6.2c5.3,5.3,11.3,11.3,19.3,11.3s14-6,19.3-11.3c1.8-1.8,4.7-4.7,6.2-5.8
		c0.6,0.7,1.2,1.7,1.8,2.4c3.9,5.5,10.4,14.7,25.2,14.7c0.9,0,23-0.3,34.1-22.3l-15.7-7.8c-6.1,12.2-18,12.7-18.4,12.7
		c-5.5,0-7.4-2.4-10.9-7.3c-2.9-4.1-7.2-10.2-15.4-10.2c-8,0-14,6-19.3,11.3c-2.2,2.2-5.8,5.8-6.6,6.2c-1.5-0.4-5.1-4.1-7.3-6.2
		c-5.3-5.3-11.3-11.3-19.3-11.3c-12,0-22.5,10.2-23.7,11.3l12.3,12.4C297.4,547.4,302.7,543.7,305.8,543.7L305.8,543.7z"/>
      <path d="M288.7,447.5c0,7.2-5.9,13.1-13.1,13.1s-13.1-5.9-13.1-13.1s5.9-13.1,13.1-13.1S288.7,440.2,288.7,447.5"/>
      <path d="M437.4,447.5c0,7.2-5.9,13.1-13.1,13.1s-13.1-5.9-13.1-13.1s5.9-13.1,13.1-13.1S437.4,440.2,437.4,447.5"/>
      <path d="M332.7,400.3c56.7,0,102.7-47.4,102.7-105.7c0-53-41.9-96-93.4-96c-46.8,0-84.9,39.2-84.9,87.3c0,43.8,34.7,79.5,77.3,79.5
		c38.8,0,70.4-32.5,70.4-72.4c0-36.4-28.8-66-64.3-66c-32.4,0-58.7,27.1-58.7,60.3c0,30.4,24.1,55.1,53.7,55.1
		c27.2,0,49.2-22.7,49.2-50.5h-17.5c0,18.2-14.2,33-31.7,33c-20,0-36.2-16.9-36.2-37.6c0-23.6,18.5-42.8,41.2-42.8
		c25.8,0,46.8,21.8,46.8,48.5c0,30.3-23.7,54.9-52.9,54.9c-33,0-59.8-27.8-59.8-62c0-38.5,30.2-69.8,67.4-69.8
		c41.8,0,75.9,35.2,75.9,78.5c0,48.7-38.2,88.2-85.2,88.2c-52.8,0-95.7-44.4-95.7-99c0-61.2,48.1-111,107.3-111
		c66.3,0,120.2,55.8,120.2,124.3H482c0-78.2-61.8-141.8-137.7-141.8c-68.8,0-124.8,57.6-124.8,128.5
		C219.5,348.1,270.3,400.3,332.7,400.3L332.7,400.3z"/>
    </g>
  </svg>
);

export const NdeMixedIcon = props => <Icon component={NdeMixedSvg} {...props} />;
